import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useStyledBlock, StyleControls, AdvancedStyleControls } from "./StyleControls";
import { MediaPickerField } from "./MediaPickerField";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";
import type { ResponsiveStyleProps } from "@/lib/craft/style-props";

type HeroProps = {
  eyebrow?: string;
  title: string;
  backgroundImage?: string;
  backgroundMediaId?: string | null;
  overlayOpacity?: number;
  style?: ResponsiveStyleProps;
};

export function HeroBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<HeroProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Eyebrow</Label>
          <Input
            className="h-8 text-xs"
            value={props.eyebrow ?? ""}
            onChange={(e) => setProp((p) => { p.eyebrow = e.target.value; })}
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Title</Label>
          <Input
            className="h-8 text-xs"
            value={props.title ?? ""}
            onChange={(e) => setProp((p) => { p.title = e.target.value; })}
          />
        </div>
        <MediaPickerField
          label="Background image"
          value={{
            mediaId: props.backgroundMediaId ?? null,
            url: props.backgroundImage ?? null,
            altText: null,
          }}
          onChange={(sel) =>
            setProp((p) => {
              p.backgroundMediaId = sel.mediaId;
              p.backgroundImage = sel.url ?? undefined;
            })
          }
        />
        <div className="space-y-1">
          <Label className="text-xs">Overlay opacity ({Math.round((props.overlayOpacity ?? 0) * 100)}%)</Label>
          <Input
            type="range"
            min={0}
            max={100}
            value={Math.round((props.overlayOpacity ?? 0) * 100)}
            onChange={(e) =>
              setProp((p) => { p.overlayOpacity = Number(e.target.value) / 100; })
            }
          />
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
  }
  return <AdvancedStyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
}
